<template>
  <div>
    <v-card>
      <v-fab-transition>
        <v-btn small color="purple" dark top right fab absolute style="transform: translateY(-20px);" @click="addLocationDialogVisible=true" v-if="drawerOpen">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-fab-transition>
      <v-dialog v-model="addLocationDialogVisible" max-width="600px" class="my-16">
          <AddLocation @closeAddLocationDialog="closeAddLocationDialog"></AddLocation>
      </v-dialog>
      <v-timeline v-for="loc in $store.state.myLocations" :key="loc.arrival_date" class="blue lighten-4" align-top dense>
        <v-timeline-item class="rounded-xl" :class="{'current-location': loc.tense === 'present'}">
          <template v-slot:icon >
            <v-avatar size="70" @click="openDialog(loc)">
              <v-img :src="loc.picUrl" lazy-src="~@/assets/alberta-2297204_1920.jpg"></v-img>
            </v-avatar>
          </template>
          <v-list-item-title @click="openDialog(loc)" style="text-align: center; white-space: pre-wrap">{{loc.locationName.split(", ")[0]}}, {{loc.locationName.split(", ")[1]}}</v-list-item-title>
          <v-list-item-title v-if="loc.departure_date">{{formattedDateRange(loc.arrival_date, loc.departure_date)}}</v-list-item-title>
          <v-list-item-title v-else>Since {{formattedDate(loc.arrival_date)}}</v-list-item-title>
        </v-timeline-item>
      </v-timeline>
    </v-card>

    <v-dialog v-model="dialogVisible" max-width="600px">
      <v-card rounded="xxl" class="myLocationCard">
        <v-img :src="this.dialogLocation.picUrl" height="20vh"><div style="color: white" class="picAttribution" v-html="this.dialogLocation.picAtt"></div></v-img>
        <v-card-title>{{ this.dialogLocation.locationName.split(", ")[0] }}</v-card-title>
        <v-card-subtitle>{{this.dialogLocation.locationName.split(", ")[1]}}</v-card-subtitle>
        <v-card-subtitle v-if="this.dialogLocation.departure_date">{{formattedDateRange(this.dialogLocation.arrival_date, this.dialogLocation.departure_date)}}</v-card-subtitle>
        <v-card-subtitle v-else>Since {{formattedDate(this.dialogLocation.arrival_date)}}</v-card-subtitle>
        <v-btn shaped @click="deleteMyStay()" color="red" style="margin: 15px; text-transform: capitalize"><v-icon small>mdi-delete</v-icon> Delete this Stay</v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import supabase from "@/lib/supabaseClient";
import {store} from "@/store";
import AddLocation from "@/components/AddLocation.vue";


export default {
  name: "MyLocations",
  props: ['drawerOpen'],
  computed: {
    store() {
      return store
    },
  },
  components: {AddLocation},
  data() {
    return {
      dialogLocation: {"locationName":" , "},
      addLocationDialogVisible: false,
      existingPlace: null,
      dialogVisible: false,
      userProfileData: {},
      userProfileDepartureDate: null,
    }
  },
  methods: {
    formattedDate(dateString) {
      dateString = dateString + 'T12:00:00'
      let date = new Date(dateString);
      date.setDate(date.getDate());
      const options = { year: "numeric", month: "short", day: "numeric" };
      return date.toLocaleDateString(undefined, options);
    },
    formattedDateRange(arrival, departure) {
      arrival = arrival + 'T12:00:00'
      departure = departure + 'T12:00:00'
      let arrivalDate = new Date(arrival);
      arrivalDate.setDate(arrivalDate.getDate());
      let departureDate = new Date(departure);
      departureDate.setDate(departureDate.getDate());

      const arrivalDay = arrivalDate.getDate();
      const departureDay = departureDate.getDate();
      const arrivalMonth = arrivalDate.toLocaleString('default', { month: 'short' }); // e.g., May
      const arrivalYear = arrivalDate.getFullYear();

      if (arrivalMonth === departureDate.toLocaleString('default', { month: 'short' }) && arrivalYear === departureDate.getFullYear()) {
        return `${arrivalDay} - ${departureDay} ${arrivalMonth}, ${arrivalYear}`
      } else if (arrivalYear === departureDate.getFullYear()) {
        let departureMonth = departureDate.toLocaleString('default', { month: 'short' });
        return `${arrivalMonth} ${arrivalDay} - ${departureMonth} ${departureDay}, ${arrivalYear}`
      } else {
        let departureMonth = departureDate.toLocaleString('default', { month: 'short' });
        return `${arrivalMonth} ${arrivalDay}, ${arrivalYear} - ${departureMonth} ${departureDay}, ${departureDate.getFullYear()}`
      }
    },
    closeAddLocationDialog() {
      this.addLocationDialogVisible = false
    },
    openDialog(location) {
      this.dialogLocation = location;
      this.dialogVisible = true;
    },
    async deleteMyStay() {
      const { error } = await supabase.from('stays').delete().eq('id', this.dialogLocation.id)
      if (error) {
        console.error("Error deleting PersonalStays from Supabase:", error);
      }
      await store.dispatch("getMyLocations")
      await store.dispatch("getTopLocations")
      await store.dispatch("getUserData")
      this.dialogVisible = false
    },

  },
}
</script>

<style scoped>
.myLocationCard {
  background-color: #A9C9FF;
  background-image: linear-gradient(180deg, #A9C9FF 0%, #FFBBEC 100%);
}

.current-location {
  text-shadow: 0 0 black;
}
</style>
